(() => {
  const goAccount = (event) => {
    const link = event.target.closest('[data-mora-account-link], a[href="/account/login"], a[href="/account"]');
    if (!link) return;
    const href = link.getAttribute('href') || '/account';
    if (href.includes('/account')) {
      event.preventDefault();
      event.stopPropagation();
      try {
        window.top.location.href = '/account';
      } catch (e) {
        window.location.href = '/account';
      }
    }
  };
  document.addEventListener('click', goAccount, true);
})();
